export type VeraPromptGuideKey =
  | 'global_system'
  | 'global_intent'
  | 'global_grounding'
  | 'admin_coaching'
  | 'admin_intent'
  | 'admin_grounding';

export interface VeraPromptGuideOptions {
  /** Investor global chat: global config or sandbox toggle. */
  googleSearchEnabled?: boolean;
  /** Investor global chat: whether citation links are returned to clients. */
  googleSearchLinksEnabled?: boolean;
}

export function searchStatusLine(options: VeraPromptGuideOptions): string {
  if (!options.googleSearchEnabled) {
    return 'Google Search is **off** in this sandbox (and globally, unless you enable it in Global Configuration). The Google Search prompt is not applied in production preview runs.';
  }
  const links = options.googleSearchLinksEnabled
    ? 'Citation links are **on** — clients may show numbered source chips when the model grounds a reply.'
    : 'Citation links are **off** — search may still run, but source metadata is stripped from API responses.';
  return `Google Search is **on** for this sandbox (global config and/or sandbox toggle). ${links}`;
}
